"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9382],{

/***/ 34094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92777);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82262);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10748);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81531);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37247);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31157);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85169);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32460);
/* harmony import */ var _components_texts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45945);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _createSuper(Derived) {var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {var Super = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result);};}function _isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}





var Element = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].input.withConfig({ displayName: "Input__Element", componentId: "sc-1j73vfk-0" })(["", "  width:100%;background-color:#ffffff;padding:11px;font-size:16px;outline:0;&::placeholder{font-size:13px;color:#c7c7c7;}&:disabled{background-color:#eaeaea;}", ";", ";"],

function (props) {return (
    props.borders &&
    (0,_lib_helpers__WEBPACK_IMPORTED_MODULE_4__/* .borders */ .Lz)(props.borders));},



















function (props) {return (
    props.dirty &&
    props.valid === false && "\n      border-color: #e53b4d;\n      background-image: url('/img/ic_close.svg');\n      background-repeat: no-repeat;\n      background-position-x: 95%;\n      background-position-y: 15px;\n      background-size: 7.5px;\n    ");},












function (props) {return (
    props.maxLengthError && "\n      border: 1px solid red;\n    ");});var





Input = /*#__PURE__*/function (_Component) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(Input, _Component);var _super = _createSuper(Input);function Input() {var _this;(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, Input);for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}_this = _super.call.apply(_super, [this].concat(args));(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_this), "state",
    {
      value: '',
      dirty: false,
      valid: false });(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_this), "isValid",
















    function (value) {
      return value === 'valid';
    });(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_this), "onChange",

    function (event) {
      _this.setState(
      {
        value: event.target.value,
        dirty: true,
        valid: _this.isValid(event.target.value) },

      function () {var _this$props, _this$props$onChange;
        (_this$props = _this.props) === null || _this$props === void 0 ? void 0 : (_this$props$onChange = _this$props.onChange) === null || _this$props$onChange === void 0 ? void 0 : _this$props$onChange.call(_this$props, _this.state.value);
      });

    });return _this;}(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(Input, [{ key: "componentDidMount", value: function componentDidMount() {this.setState({ value: this.props.value });} }, { key: "componentDidUpdate", value: function componentDidUpdate(prevProps) {if (this.props.value !== prevProps.value) {this.setState({ value: this.props.value });}} }, { key: "render", value:

    function render() {
      return /*#__PURE__*/(
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, { children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Element, _objectSpread(_objectSpread({},
          this.props), {}, {
            valid: true,
            dirty: this.state.dirty,
            value: this.state.value,
            onChange: this.onChange,
            maxLengthError:
            this.props.value && this.props.value.length >= this.props.maxLength })),


          this.props.value && this.props.value.length >= this.props.maxLength ? /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_5__/* .FormHelper */ .wK, { children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_12__/* .Trans */ .cC, {
              id: "errors.maxlength",
              message: "You can't have more than {maxLength} characters",
              values: { maxLength: this.props.maxLength } }) }) :


          null] }));


    } }]);return Input;}(react__WEBPACK_IMPORTED_MODULE_3__.Component);


Input.defaultProps = { borders: 'both' };

/* harmony default export */ __webpack_exports__["Z"] = (Input);

/***/ }),

/***/ 45330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


var Input = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].input.withConfig({ displayName: "Input2__Input", componentId: "sc-1orwxqf-0" })(["width:100%;background-color:", ";padding:11px;font-size:16px;outline:0;border:1px solid ", ";border-top-left-radius:5px;border-bottom-left-radius:5px;", ""],





function (props) {return props.theme.colors.neutrals.white;},




function (props) {return (
    props.errorStyle ?
    props.theme.colors.secondary['red-1'] :
    props.theme.colors.interactive['color-18']);},


function (props) {return (
    props.borderRadiusComplete ? "\n          border-top-right-radius: 5px;\n          border-bottom-right-radius: 5px;\n        " :




    '');});
















var Input2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
function (props, ref) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Input, _objectSpread({
      ref: ref,
      type: props.type,
      id: props.id,
      value: props.value,
      readOnly: props.readOnly,
      onChange: props.onChange,
      onClick: props.onClick,
      errorStyle: props.errorStyle,
      style: props.style,
      borderRadiusComplete: props.borderRadiusComplete },
    props)));});




/* harmony default export */ __webpack_exports__["Z"] = (Input2);

/***/ }),

/***/ 14197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31157);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85169);
/* harmony import */ var _components_texts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45945);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var Element = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].textarea.withConfig({ displayName: "TextArea__Element", componentId: "sc-yexej8-0" })(["width:100%;min-height:140px;border-radius:5px;border:solid 1px #dddddd;padding:11px;outline:0;resize:none;font-size:16px;&:disabled{background-color:#f7f7f7;}&:focus{border:1px solid #129edc;}&::-webkit-input-placeholder{font-size:13px;color:#c7c7c7;}&:-moz-placeholder{font-size:13px;color:#c7c7c7;}&::-moz-placeholder{font-size:13px;color:#c7c7c7;}&:-ms-input-placeholder{font-size:13px;color:#c7c7c7;}", ";"],








































function (props) {return props.maxLengthError && "border: 1px solid red;";});


var TextArea = function TextArea(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Element, {
        className: props.className,
        name: props.name,
        id: props.id,
        onChange: props.onChange,
        onBlur: props.onBlur,
        placeholder: props.placeholder,
        value: props.value,
        maxLength: props.maxLength,
        maxLengthError: props.value && props.value.length >= props.maxLength,
        disabled: props.disabled }),

      props.value && props.value.length >= props.maxLength ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_1__/* .FormHelper */ .wK, { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, {
          id: "errors.maxlength",
          message: "You can't have more than {length} characters",
          values: { length: props.maxLength } }) }) :


      null] }));


};

/* harmony default export */ __webpack_exports__["Z"] = (TextArea);

/***/ }),

/***/ 27482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export Text */
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54444);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({ displayName: "Banner__Wrapper", componentId: "sc-y0zgnw-0" })(["flex:1;display:flex;justify-content:space-between;align-items:center;border-radius:4px;padding:20px;background-color:", ";cursor:", ";@media (max-width:", "){flex-direction:column;}"],






function (_ref) {var appearance = _ref.appearance;
  if (appearance === 'error') {
    return '#F5C6CB';
  } else if (appearance === 'warning') {
    return '#FFE9CB';
  } else if (appearance === 'info') {
    return '#d6d8db';
  } else if (appearance === 'success') {
    return '#DCE7E7';
  } else {
    return '#E5F4FE';
  }
},
function (p) {return typeof p.onClick === 'function' ? 'pointer' : 'auto';},
function (props) {return "".concat(props.theme.viewports.tablet, "px");});




var Text = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].p.withConfig({ displayName: "Banner__Text", componentId: "sc-y0zgnw-1" })(["display:flex;align-items:baseline;font-size:14px;color:#3c3c3c;margin:0;", ";", ";"],





function (props) {return props.noMargin && 'margin: 0;';},
function (props) {return (
    !props.noMargin && "\n    @media (max-width: ".concat(

    function (props) {return "".concat(props.theme.viewports.tablet, "px");}, ") {\n      margin-bottom: 20px;\n    }\n  "));});


















var Banner = function Banner(props) {var _props$style;
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
      className: props.className,
      style: props.style,
      onClick: props.onClick,
      appearance: props.appearance, children: /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Text, { style: { color: props === null || props === void 0 ? void 0 : (_props$style = props.style) === null || _props$style === void 0 ? void 0 : _props$style.color }, noMargin: props.noMargin, children: [
        !props.disableIcon ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
          name: "ygb-icon-infob",
          fontSize: "14px",
          color: props.iconColor || '#96a0a4',
          mr: '10px' }) :

        null,
        props.children] }) }));



};

/* harmony default export */ __webpack_exports__["Z"] = (Banner);

/***/ }),

/***/ 63467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CopyInputGroup; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31157);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85169);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49613);
/* harmony import */ var _components_form_Input2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45330);
/* harmony import */ var _components_form_Label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25077);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94007);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);








var InputGroup = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div.withConfig({ displayName: "CopyInputGroup__InputGroup", componentId: "sc-4cuznb-0" })(["button{height:100%;}"]);











var CopyInputGroup = function CopyInputGroup(props) {
  var title = props.title,value = props.value,_props$disabled = props.disabled,disabled = _props$disabled === void 0 ? false : _props$disabled;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),copied = _useState[0],setCopied = _useState[1];
  var _textInputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  var handleCopy = function handleCopy() {
    if (!disabled) {
      _textInputRef.current.select();
      document.execCommand('copy');
      _textInputRef.current.blur();
      setCopied(true);
    }
  };

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(InputGroup, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, { mb: "7px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_form_Label__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { htmlFor: "shareModalCode", children: title }) }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, { children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, { flex: "1", children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_form_Input2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            id: "shareModalCode",
            ref: _textInputRef,
            type: "text",
            readOnly: true,
            value: value,
            onClick: handleCopy }) }), /*#__PURE__*/


        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, { children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, { borderRadiuslessLeft: true, onClick: handleCopy, disabled: disabled, children:
            copied ? /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_7__/* .Trans */ .cC, { id: "share_modal.copied_button", message: 'Copied !' }) : /*#__PURE__*/

            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_7__/* .Trans */ .cC, {
              id: "settings_referall.personal_code_action",
              message: "Copy" }) }) })] })] }));







};

/***/ }),

/***/ 24331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ modals_PlaylistModal; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@lingui/core/esm/index.js + 1 modules
var esm = __webpack_require__(94471);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(12922);
// EXTERNAL MODULE: ./components/buttons.js
var buttons = __webpack_require__(49613);
// EXTERNAL MODULE: ./components/form/Input.js
var Input = __webpack_require__(34094);
// EXTERNAL MODULE: ./components/form/Label.js
var Label = __webpack_require__(25077);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Radio/Radio.js + 5 modules
var Radio_Radio = __webpack_require__(24691);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/RadioButtonChecked.js
var RadioButtonChecked = __webpack_require__(32554);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/RadioButtonUnchecked.js
var RadioButtonUnchecked = __webpack_require__(85311);
// EXTERNAL MODULE: ./lib/theme.ts
var theme = __webpack_require__(62594);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/form/radio/Label.js




var styles = {
  label: {
    fontSize: '13px' } };



/* harmony default export */ var radio_Label = ((0,withStyles/* default */.Z)(styles)(function (props) {return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
      label: props.label,
      style: {
        marginLeft: 0,
        marginRight: 0,
        height: '100%' },

      control: props.children,
      classes: {
        label: props.classes.label } }));}));
;// CONCATENATED MODULE: ./components/form/radio/Radio.js








var Radio_styles = {
  root: {
    height: '100%',
    width: '15px',
    marginRight: '7px',
    '&$checked': {
      color: theme/* default.colors.primary.blue-2 */.Z.colors.primary["blue-2"] } },


  checked: {},
  sizeIcon: {
    fontSize: 15 } };



var Radio = function Radio(_ref) {var label = _ref.label,isChecked = _ref.isChecked,handleChange = _ref.handleChange,classes = _ref.classes;
  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(radio_Label, { label: label, htmlFor: label, children: /*#__PURE__*/
      (0,jsx_runtime.jsx)(Radio_Radio/* default */.Z, {
        id: label,
        checked: isChecked,
        onChange: handleChange,
        classes: {
          root: classes.root,
          checked: classes.checked },

        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(RadioButtonUnchecked/* default */.Z, { className: classes.sizeIcon }),
        checkedIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(RadioButtonChecked/* default */.Z, { className: classes.sizeIcon }) }) }));



};

/* harmony default export */ var radio_Radio = ((0,withStyles/* default */.Z)(Radio_styles)(Radio));
// EXTERNAL MODULE: ./components/form/TextArea.js
var TextArea = __webpack_require__(14197);
// EXTERNAL MODULE: ./components/layout/Grid.ts
var Grid = __webpack_require__(94007);
// EXTERNAL MODULE: ./lib/apollo/policies/index.ts + 23 modules
var policies = __webpack_require__(54734);
// EXTERNAL MODULE: ./components/typography/Headings.tsx
var Headings = __webpack_require__(94268);
// EXTERNAL MODULE: ./components/typography/Paragraph.js
var Paragraph = __webpack_require__(36225);
// EXTERNAL MODULE: ./node_modules/@lingui/react/esm/index.js + 1 modules
var react_esm = __webpack_require__(85169);
// EXTERNAL MODULE: ./organisms/Banner.tsx
var Banner = __webpack_require__(27482);
// EXTERNAL MODULE: ./organisms/modals/base/index.tsx + 3 modules
var base = __webpack_require__(10842);
// EXTERNAL MODULE: ./gql/generated/index.tsx
var generated = __webpack_require__(48354);
// EXTERNAL MODULE: ./lib/contexts/UserProvider.tsx
var UserProvider = __webpack_require__(47493);
// EXTERNAL MODULE: ./lib/analytics/manager.ts + 4 modules
var manager = __webpack_require__(88224);
;// CONCATENATED MODULE: ./organisms/modals/PlaylistModal.tsx
var _templateObject, _templateObject2;





















var PATCH_PLAYLIST = (0,lib/* default */.ZP)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  mutation patchPlaylist(\n    $id: ID!\n    $title: String!\n    $visibility: String\n    $description: String\n  ) {\n    patchPlaylist(\n      id: $id\n      title: $title\n      visibility: $visibility\n      description: $description\n    ) {\n      playlist {\n        id\n        title\n        visibility\n        description\n      }\n    }\n  }\n"])));






















var STORE_PLAYLIST = (0,lib/* default */.ZP)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  mutation addPlaylist(\n    $title: String!\n    $visibility: String\n    $description: String\n  ) {\n    addPlaylist(\n      title: $title\n      visibility: $visibility\n      description: $description\n    ) {\n      playlist {\n        id\n      }\n    }\n  }\n"])));

















// TODO: convert this into hook style component
var PlaylistModal = function PlaylistModal(props) {var _props$playlist, _props$playlist2, _props$playlist3, _currentUser$privacyS;
  var _useRouter = (0,router.useRouter)(),query = _useRouter.query;
  var _useState = (0,react.useState)(((_props$playlist = props.playlist) === null || _props$playlist === void 0 ? void 0 : _props$playlist.title) || ''),title = _useState[0],setTitle = _useState[1];
  var _useState2 = (0,react.useState)(
  ((_props$playlist2 = props.playlist) === null || _props$playlist2 === void 0 ? void 0 : _props$playlist2.description) || ''),description = _useState2[0],setDescription = _useState2[1];

  var _useState3 = (0,react.useState)(
  ((_props$playlist3 = props.playlist) === null || _props$playlist3 === void 0 ? void 0 : _props$playlist3.visibility) || 'hidden'),visibility = _useState3[0],setVisibility = _useState3[1];

  var _useState4 = (0,react.useState)(false),open = _useState4[0],toggleModal = _useState4[1];
  var _useState5 = (0,react.useState)(false),loading = _useState5[0],setLoading = _useState5[1];
  var _useContext = (0,react.useContext)(UserProvider/* UserContext */.S),currentUser = _useContext[0];
  var _useUserPlaylistsLazy = (0,generated/* useUserPlaylistsLazyQuery */.y9j)(),_useUserPlaylistsLazy2 = (0,slicedToArray/* default */.Z)(_useUserPlaylistsLazy, 2),_ = _useUserPlaylistsLazy2[0],refetch = _useUserPlaylistsLazy2[1].refetch;
  var _useMutation = (0,useMutation/* useMutation */.D)(STORE_PLAYLIST),_useMutation2 = (0,slicedToArray/* default */.Z)(_useMutation, 1),addPlaylistMutation = _useMutation2[0];
  var _useMutation3 = (0,useMutation/* useMutation */.D)(

  PATCH_PLAYLIST),_useMutation4 = (0,slicedToArray/* default */.Z)(_useMutation3, 1),patchPlaylistMutation = _useMutation4[0];

  var handleOpenModal = function handleOpenModal() {
    toggleModal(true);
  };

  var handleCloseModal = function handleCloseModal() {var _props$onModalClose;
    toggleModal(false);
    (_props$onModalClose = props.onModalClose) === null || _props$onModalClose === void 0 ? void 0 : _props$onModalClose.call(props);
  };

  var storePlaylist = function storePlaylist() {
    return addPlaylistMutation({
      variables: {
        title: String(title).trim(),
        visibility: visibility,
        description: String(description).trim() } }).

    then( /*#__PURE__*/function () {var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(response) {var playlistID;return regenerator_default().wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                  refetch({ page: 1, perPage: 12 }));case 2:
                // PLAYLIST TODO: handle errors
                playlistID = response.data.addPlaylist.playlist.id;_context.next = 5;return (
                  props.onCompletedStorePlaylist(playlistID));case 5:
                (0,manager/* default */.Z)().sendPlaylistCreatedEvent({ playlist_id: playlistID });
                (0,policies/* snackbarVar */.Ck)({
                  isSnackBarOpen: true,
                  goTo: 'PLAYLIST',
                  id: playlistID,
                  snackBarMessage: /*i18n*/esm/* i18n._ */.ag._("snackbars.created_playlist") });

                handleCloseModal();case 8:case "end":return _context.stop();}}}, _callee);}));return function (_x) {return _ref.apply(this, arguments);};}());

  };

  var patchPlaylist = function patchPlaylist() {
    return patchPlaylistMutation({
      variables: {
        id: props.playlist.id,
        title: title,
        visibility: visibility,
        description: description } }).

    then(function () {
      // PLAYLIST TODO: handle errors
      handleCloseModal();
      (0,policies/* snackbarVar */.Ck)({
        isSnackBarOpen: true,
        goTo: 'PLAYLIST',
        snackBarMessage: /*i18n*/esm/* i18n._ */.ag._("snackbars.updated_playlist"),
        id: props.playlist.id });

    });
  };

  var handleSubmit = /*#__PURE__*/function () {var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(e) {return regenerator_default().wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:
              e.preventDefault();
              setLoading(true);if (!
              props.playlist) {_context2.next = 7;break;}_context2.next = 5;return (
                patchPlaylist());case 5:_context2.next = 9;break;case 7:_context2.next = 9;return (

                storePlaylist());case 9:

              setLoading(false);case 10:case "end":return _context2.stop();}}}, _callee2);}));return function handleSubmit(_x2) {return _ref2.apply(this, arguments);};}();


  var isFormValid =
  title.length < 2 || title.length > 40 || description.length > 400;

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(react.Fragment, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(base/* Modal */.u_, {
        open: open,
        handleClose: handleCloseModal, children: /*#__PURE__*/


        (0,jsx_runtime.jsxs)("form", { onSubmit: handleSubmit, children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(base/* Header */.h4, { handleClose: handleCloseModal, children: /*#__PURE__*/
            (0,jsx_runtime.jsxs)(Grid/* Box */.xu, { as: Headings.H4, color: "#242424", mt: "0px", mb: "0px", children: [
              visibility === 'public' && /*#__PURE__*/
              (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                id: "createplaylist_modal.public_title",
                message: 'Public Playlist' }),


              visibility === 'hidden' && /*#__PURE__*/
              (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                id: "createplaylist_modal.hidden_title",
                message: 'Hidden Playlist' }),


              visibility === 'private' && /*#__PURE__*/
              (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                id: "createplaylist_modal.private_title",
                message: 'Private Playlist' })] }) }), /*#__PURE__*/




          (0,jsx_runtime.jsxs)(base/* Body */.uT, { children: [/*#__PURE__*/
            (0,jsx_runtime.jsxs)(Grid/* Box */.xu, { mb: "10px", children: [/*#__PURE__*/
              (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: "7px", children: /*#__PURE__*/
                (0,jsx_runtime.jsx)(Label/* default */.Z, { htmlFor: 'title', children: /*#__PURE__*/
                  (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                    id: "createplaylist_modal.name.label",
                    message: 'Name' }) }) }), /*#__PURE__*/



              (0,jsx_runtime.jsx)(Input/* default */.Z, {
                id: "title",
                placeholder: /*i18n*/esm/* i18n._ */.ag._("createplaylist_modal.name.placeholder"),
                value: title,
                onChange: function onChange(value) {
                  setTitle(String(value).trim());
                },
                required: true,
                minLength: 2,
                maxLength: 40 })] }), /*#__PURE__*/


            (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: "10px", children: /*#__PURE__*/
              (0,jsx_runtime.jsxs)(Grid/* Flex */.kC, { children: [/*#__PURE__*/
                (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mr: 30, children: /*#__PURE__*/
                  (0,jsx_runtime.jsx)(radio_Radio, {
                    label: /*#__PURE__*/
                    (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                      id: "createplaylist_modal.options.one",
                      message: 'Public' }),


                    isChecked: visibility === 'public',
                    handleChange: function handleChange() {
                      setVisibility('public');
                    } }) }), /*#__PURE__*/


                (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mr: 30, children: /*#__PURE__*/
                  (0,jsx_runtime.jsx)(radio_Radio, {
                    label: /*#__PURE__*/
                    (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                      id: "createplaylist_modal.options.two",
                      message: "Hidden" }),


                    isChecked: visibility === 'hidden',
                    handleChange: function handleChange() {
                      setVisibility('hidden');
                    } }) }), /*#__PURE__*/


                (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mr: 30, children: /*#__PURE__*/
                  (0,jsx_runtime.jsx)(radio_Radio, {
                    label: /*#__PURE__*/
                    (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                      id: "createplaylist_modal.options.three",
                      message: "Private" }),


                    isChecked: visibility === 'private',
                    handleChange: function handleChange() {
                      setVisibility('private');
                    } }) })] }) }), /*#__PURE__*/




            (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: "10px", children: /*#__PURE__*/
              (0,jsx_runtime.jsxs)(Paragraph.P, { color: "#242424", children: [
                visibility === 'public' && /*#__PURE__*/
                (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                  id: "createplaylist_modal.public_helper",
                  message:
                  'Your playlist gets shown in public listings and may be promoted to other users.' }),



                visibility === 'hidden' && /*#__PURE__*/
                (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                  id: "createplaylist_modal.hidden_helper",
                  message: 'Your playlist is hidden.' }),


                visibility === 'private' && /*#__PURE__*/
                (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                  id: "createplaylist_modal.private_helper",
                  message: 'Your playlist is private.' })] }) }),




            currentUser !== null && currentUser !== void 0 && (_currentUser$privacyS = currentUser.privacySettings) !== null && _currentUser$privacyS !== void 0 && _currentUser$privacyS.isPrivateProfile &&
            visibility === 'public' ? /*#__PURE__*/
            (0,jsx_runtime.jsx)(Grid/* Box */.xu, { my: '10px', children: /*#__PURE__*/
              (0,jsx_runtime.jsx)(Banner/* default */.Z, {
                style: {
                  backgroundColor: '#FFE9CB' },

                iconColor: '#242424',
                noMargin: true, children: /*#__PURE__*/

                (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                  id: "createplaylist_modal.privacy_helper",
                  message:
                  'Your profile is currently set to private but this playlist will still be visible to the public. <0>Edit Privacy Settings.</0>',

                  components: [/*#__PURE__*/
                  (0,jsx_runtime.jsx)((link_default()), {

                    href: "/[lang]/me/settings/[pageId]",
                    as: "/".concat(query.lang, "/me/settings/privacy-settings") }, "privacy")] }) }) }) :







            null, /*#__PURE__*/
            (0,jsx_runtime.jsxs)(Grid/* Box */.xu, { mb: "10px", children: [/*#__PURE__*/
              (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: "7px", children: /*#__PURE__*/
                (0,jsx_runtime.jsx)(Label/* default */.Z, { htmlFor: 'description', children: /*#__PURE__*/
                  (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                    id: "createplaylist_modal.description.label",
                    message: 'Description' }) }) }), /*#__PURE__*/



              (0,jsx_runtime.jsx)(TextArea/* default */.Z, {
                id: 'description',
                placeholder: /*i18n*/esm/* i18n._ */.ag._("createplaylist_modal.description.placeholder"),
                value: description,
                maxLength: 400,
                onChange: function onChange(e) {
                  setDescription(e.target.value);
                } })] })] }), /*#__PURE__*/



          (0,jsx_runtime.jsxs)(base/* Footer */.$_, { children: [/*#__PURE__*/
            (0,jsx_runtime.jsx)(buttons/* default */.ZP, { appearance: "link", type: "reset", onClick: handleCloseModal, children: /*#__PURE__*/
              (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                id: "createplaylist_modal.actions.secondary",
                message: 'CANCEL' }) }), /*#__PURE__*/


            (0,jsx_runtime.jsx)(buttons/* default */.ZP, { loading: loading, disabled: isFormValid, type: "submit", children: /*#__PURE__*/
              (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                id: "createplaylist_modal.actions.primary",
                message: 'SAVE' }) })] })] }) }),





      props.children(handleOpenModal)] }));


};

/* harmony default export */ var modals_PlaylistModal = (PlaylistModal);

/***/ }),

/***/ 29382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(16573);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(1020);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(46616);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(87385);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(48137);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(66339);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31157);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49613);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94007);
/* harmony import */ var _components_typography_Headings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94268);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85169);
/* harmony import */ var _organisms_Banner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27482);
/* harmony import */ var _lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17516);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10842);
/* harmony import */ var _PlaylistModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24331);
/* harmony import */ var _lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47493);
/* harmony import */ var _lib_analytics_manager__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88224);
/* harmony import */ var _organisms_CopyInputGroup__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(63467);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85893);
var _excluded = ["subject"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}













var IconsContainer = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].div.withConfig({ displayName: "ShareModal__IconsContainer", componentId: "sc-a49myo-0" })(["display:flex;flex-direction:row;justify-content:flex-start;align-items:center;.react-share-icon:hover{cursor:pointer;}"]);










var size = 30;

var IconStyle = {
  marginRight: '10px',
  borderRadius: '3px',
  overflow: 'hidden' };


var renderPrivacyBanner = function renderPrivacyBanner(playlist) {
  if (playlist.visibility === 'public') return null;

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: 25, children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_organisms_Banner__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        style: {
          marginBottom: '30px',
          backgroundColor: '#FFE9CB' },

        iconColor: '#242424', children: /*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_PlaylistModal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, { playlist: playlist, children:
          function children(openModal) {return (
              playlist.visibility === 'hidden' ? /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_14__/* .Trans */ .cC, {
                id: 'share_modal.hidden',
                message:
                'You can share this playlist but it can only be accessed via the link/URL. <0>Edit playlist settings.</0>',

                components: [/*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {

                  appearance: "link",
                  onClick: openModal }, "privacy")] }) : /*#__PURE__*/




              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_14__/* .Trans */ .cC, {
                id: 'share_modal.privacy',
                message:
                'You can still share this playlist but no one will be able to see it. <0>Edit playlist settings.</0>',

                components: [/*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {

                  appearance: "link",
                  onClick: openModal }, "privacy")] }));} }, "playlist") }) }));









};

var ShareModal = function ShareModal(_ref) {var _props$shareURL, _props$playlist, _props$shareURL2, _props$shareURL3;var _ref$subject = _ref.subject,subject = _ref$subject === void 0 ? 'Yogobe Video' : _ref$subject,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),open = _useState[0],setOpen = _useState[1];
  var lang = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z);
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_9__/* .UserContext */ .S),currentUser = _useContext[0],loading = _useContext[1].loading;

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (currentUser !== null && currentUser !== void 0 && currentUser.id && open && props.resource === 'videos') {
      (0,_lib_analytics_manager__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)().sendClickedShareVideoEvent({
        videoId: props.resourceIdentifier });

    }
  }, [open]);

  var formattedUrl = function formattedUrl(_ref2) {var id = _ref2.id,_ref2$resource = _ref2.resource,resource = _ref2$resource === void 0 ? 'videos' : _ref2$resource;
    var domain = "https://devenv.yogobe.com";
    if (resource === 'program') return id;
    return "".concat(domain, "/").concat(lang, "/").concat(resource, "/").concat(id);
  };

  var iconParams = {
    className: 'react-share-icon',
    style: IconStyle,
    url: (_props$shareURL =
    props.shareURL) !== null && _props$shareURL !== void 0 ? _props$shareURL :
    formattedUrl({
      id: props.resourceIdentifier }) };



  var handleCloseModal = function handleCloseModal() {var _props$onModalClose;
    setOpen(false);
    (_props$onModalClose = props.onModalClose) === null || _props$onModalClose === void 0 ? void 0 : _props$onModalClose.call(props);
  };
  var handleOpenModal = function handleOpenModal() {return setOpen(true);};

  if (loading) {
    return null;
  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(_base__WEBPACK_IMPORTED_MODULE_7__/* .Modal */ .u_, {
        open: open,
        handleClose: handleCloseModal,
        customWidth: "500px", children: [/*#__PURE__*/


        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_base__WEBPACK_IMPORTED_MODULE_7__/* .Header */ .h4, { handleClose: handleCloseModal, paddingBottom: 20, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { as: _components_typography_Headings__WEBPACK_IMPORTED_MODULE_4__.H4, mt: "0px", mb: "0px", children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_14__/* .Trans */ .cC, { id: "share_modal.title", message: 'Share' }) }) }), /*#__PURE__*/


        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(_base__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, { pb: 30, children: [
          currentUser !== null && currentUser !== void 0 && currentUser.id && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) === ((_props$playlist = props.playlist) === null || _props$playlist === void 0 ? void 0 : _props$playlist.ownerId) ?
          renderPrivacyBanner(props.playlist) :
          null, /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: 25, children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(IconsContainer, { children: [/*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, iconParams), {}, { children: /*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, { size: size }) })), /*#__PURE__*/

              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, iconParams), {}, { children: /*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, { size: size }) })), /*#__PURE__*/

              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, _objectSpread(_objectSpread({},
              iconParams), {}, {
                subject: subject,
                body: (_props$shareURL2 =
                props.shareURL) !== null && _props$shareURL2 !== void 0 ? _props$shareURL2 :
                formattedUrl({
                  id: props.resourceIdentifier }), children: /*#__PURE__*/



                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, { size: size }) }))] }) }), /*#__PURE__*/



          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_organisms_CopyInputGroup__WEBPACK_IMPORTED_MODULE_11__/* .CopyInputGroup */ .x, {
              title: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_14__/* .Trans */ .cC, {
                id: "share_modal.copy_placeholder",
                message: 'Copy this url to share:' }),


              value: (_props$shareURL3 =
              props.shareURL) !== null && _props$shareURL3 !== void 0 ? _props$shareURL3 :
              formattedUrl({
                id: props.resourceIdentifier,
                resource: props.resource }) }) })] })] }),






      props.children(handleOpenModal)] }));


};

/* harmony default export */ __webpack_exports__["Z"] = (ShareModal);

/***/ })

}]);